import { createFileRoute } from '@tanstack/react-router'

import { ReducerDetailPage } from '../../../../../components/pages/backoffice/platform/platform-admin-reducers-page/reducer-detail-page/reducer-detail-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/reducers/$reducerName/')({
  component: function Component() {
    const { reducerName } = Route.useParams()
    return (
      <PermissionChecker requiredPermissions={['tech.configurations']}>
        <ReducerDetailPage reducerName={reducerName} />
      </PermissionChecker>
    )
  },
})
